import React from "react";
import { Box, Text, Alert, AlertDescription, useToast } from "@chakra-ui/react";
import { useLocation } from "react-router-dom"
 
import { View, CandidateItem, LoadMore, CustomSkeleton } from "@components";
import { search_persons } from "@lib/datahandlers/company";
import { PER_PAGE } from "@lib/constants";
import { t } from "@lang/i18n";
import { IconInfo } from "@assets/Icons";
import { saveState } from "@lib/localStorage";

const SearchResult = ({ form, isLoaded, candidates, setCandidates, setLoadMore, loadMore, generateQuery }) => {
  const toast = useToast();

  const location = useLocation().pathname;

  const isHomeRoute = (location) => {
    const res = location.split('/').filter(el => el === "home");
    if (res.length === 1) return true;
    return false;
  };

  const showMore = async () => {
    let nextPage = loadMore.page + 1;
    const SEARCH_PARAMS = ["fonctions", "contracts", "experiences", "latitude", "longitude", "department", "region", "city", "address"];
    const baseUrl = '/persons/search';
    const searchQuery = generateQuery(SEARCH_PARAMS, form, nextPage, baseUrl);  
    console.log('showMore: ', searchQuery)

    setLoadMore({...loadMore, loading_more: true})
    const result = await await search_persons(searchQuery);
    setLoadMore({...loadMore, loading_more: false})

    if(result.success) {
      setLoadMore({
        ...loadMore,
        has_more: result.data.length === PER_PAGE,
        page: nextPage,
      });
      setCandidates([...candidates, ...result.data]);
      saveState("candidates", [...candidates, ...result.data]);
      return;
    }
    toast({description: t('global.general_error'), status: "warning", variant: 'subtle', duration: 3000});
  };

  return (
    <Box>
      <View if={isHomeRoute(location)}>
        <Alert status="success" variant="subtle">
            <IconInfo />
            <AlertDescription ml="1rem">
              {t('messages.matching_algo.company')}
            </AlertDescription>
        </Alert>
      </View>
      
      <View if={!isLoaded && candidates.length > 0} mt="1rem"> 
        <Text fontSize="1rem">
          { isLoaded ? 
            t("company.search_candidates.search_result") : 
            t("company.search_candidates.search_available") } :
          <Box as="span" fontWeight="600" ml="5px">
            {candidates.length} {t("company.search_candidates.candidates")}
          </Box>
        </Text>
      </View>

      <View if={isLoaded} display="flex" flexDir="row" flexWrap="wrap" justifyContent={{base: "center", lg: "space-between"}}>
        <CustomSkeleton type="FETCH_ITEMS" /> 
        <CustomSkeleton type="FETCH_ITEMS" /> 
        <CustomSkeleton type="FETCH_ITEMS" />
      </View>

      <View if={!isLoaded} mt="24px" display="flex" flexDir="column" justifyContent={candidates.length > 0 ? "space-between" : "center"}>
        <View if={candidates.length > 0} display="flex" flexDir="row" flexWrap="wrap" justifyContent={{base: "center", lg: "space-between"}}>
          { candidates.map((el) => 
              <CandidateItem data={el} iconType="company" candidates={candidates} setCandidates={setCandidates} id={el.id} />
          )}
        </View>

        <View if={candidates.length === 0} textAlign="center" mb="70px">
          <Text color="gray.borders" fontWeight="600" fontSize="1.25rem" mt="10rem" textAlign="center">
            {t("company.search_candidates.search_none")}
          </Text>
        </View>
      </View>

      {/* Pagination */}
      <View if={loadMore.has_more} flexBasis="100%" textAlign="center">
        <LoadMore showMore={showMore} loading_more={loadMore.loading_more} />
      </View>
    </Box>
  );
};

export default SearchResult;
